import ko from 'knockout';

ko.observable.fn.increment = function (value) {
    var current = this();
    if (!Number.isInteger(current)) return;
    this(current + (value ?? 1));
};

ko.observable.fn.decrement = function (value) {
    var current = this();
    if (!Number.isInteger(current)) return;
    this(current - (value ?? 1));
};
